import React from 'react';
import { node, bool, string } from 'prop-types';
import classnames from 'classnames/bind';

import LinkFreeStanding from 'elements/Link/LinkFreeStanding/LinkFreeStanding';

import styles from './Layout.css';
const cx = classnames.bind(styles);

export const SectionHeader = ({ title, description, isSubSection = false }) => (
  <div className={cx('sectionHeader', {'subSectionHeader': isSubSection})}>
    <h1 className="main-title">{title}</h1>
    { description && <p>{description}</p>}
  </div>
);

SectionHeader.propTypes = {
  title: string.isRequired,
  description: string,
  isSubSection: bool,
};

SectionHeader.displayName = 'FormSectionHeader';

export const Row = ({ children, spaceBetween }) => {
  if (children.length > 2) {
    throw Error(`Each row have a maximum of 2 childrens. You have ${children.length}.`);
  }

  return (
    <div className={classnames(styles.formRow, 'flex flex-align-center', {'flex-justify-between': spaceBetween})}>
      {children}
    </div>
  );
};

Row.propTypes = {
  children: node.isRequired,
  spaceBetween: bool
};

Row.displayName = 'FormRow';

export const BottomActionCall = ({ icon, text, linkText }) => (
  <p className={cx('bottomActionCall', 'flex flex-align-center')}>
      {text}
      <LinkFreeStanding size="m" icon={{name:icon, type: '20', direction: 'left'}}>
        {linkText}
      </LinkFreeStanding>
  </p>
);

BottomActionCall.propTypes = {
  icon: string.isRequired,
  text: string.isRequired,
  linkText: string.isRequired,
};

BottomActionCall.displayName = 'FormSectionHeader';



// WEBPACK FOOTER //
// ./src/uis/components/Form/Layout/index.js